import React from 'react';

const generateCaptcha = () => {
    // Generate two random numbers (both between 1-20)
    const num1 = Math.floor(Math.random() * 20) + 1;
    const num2 = Math.floor(Math.random() * 20) + 1;
    
    // Use only addition to avoid negative answers
    const operator = '+';
    
    return {
        question: `${num1} ${operator} ${num2}`,
        answer: num1 + num2
    };
};

const Captcha = ({ captcha, onRefresh }) => {
    return (
        <div className="mb-3">
            <label className="form-label">سوال امنیتی (کپچا)</label>
            <div className="d-flex align-items-left">
                <button 
                    type="button" 
                    className="btn btn-outline-secondary btn-sm ms-2"
                    onClick={onRefresh}
                     style={{ 
                        border: "1px solid #000000"
                    }}
                >
                    <i class="bi bi-arrow-clockwise"></i>
                </button>
                <span className="me-3 fw-bold">{captcha.question}</span>
                
            </div>
        </div>
    );
};

export { generateCaptcha, Captcha };
